import './overrides.js';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { StrictMode, useEffect } from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { useLanguage } from './hooks/useLanguage.js';
import { dynamicActivate } from './locale/i18n.js';

function LocalizedApp() {
  const { language } = useLanguage();

  // Load translations
  useEffect(() => {
    dynamicActivate(language);
  }, [language]);

  return (
    <I18nProvider i18n={i18n}>
      <App />
    </I18nProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <LocalizedApp />
    </ErrorBoundary>
  </StrictMode>,
);
